module.exports = __webpack_public_path__ + "img/20240710103229988wt7.7613b9bc.jpg";